export const baseURL = `${
	process.env.NODE_ENV !== 'production' ? 'http://localhost:5001' : ''
}/claims/api/v2`;
export const homepage = '/claims';
export const GOOGLE_KEY =
	process.env.NODE_ENV === 'development'
		? 'AIzaSyDwc0k_y_eqac-0xfJ3L71kq_qK-fFFAfg'
		: 'AIzaSyCZ9N4GxkHU4mUnjHvF7xJUd4roTHM0nQ0';
